import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { queryKeys } from "./queryKeys";

export const useOverview = () => {
  return useQuery({
    queryKey: queryKeys.overview,
    queryFn: () => api.getOverview(),
  });
};
